export enum MaritalStatusesEnum {
  S = 'Svobodný(á)',
  M = 'Ženatý/vdaná',
  D = 'Rozvedený(á)',
  W = 'Vdovec/vdova',
}
